import React, { useState, useEffect, useContext } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useAuth0 } from "@auth0/auth0-react";

import * as REST from '~services/rest';

import NotificationsActions from '~redux/notifications';

import Button from '~components/button';

import { ChatContext } from '../../context';

const ChatReport = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { discussion, currentUser } = useContext(ChatContext);
  const { getAccessTokenSilently } = useAuth0();

  const [shouldReportChat, setShouldReportChat] = useState(false);
  const [isLoadingReportChat, setIsLoadingReportChat] = useState(false);
  const [isReported, setIsReported] = useState(discussion.isReported);

  useEffect(async () => {
    if (!shouldReportChat) {
      return;
    }
    setIsLoadingReportChat(true);

    const token = await getAccessTokenSilently();
    const request = await REST.post({
      name: `chats/${discussion.discussionId}`,
      mockFileName: 'chats/post-report',
      requiresAuthentication: true,
      params: {
        action: 'report',
        who: currentUser.personId,
      },
      token,
    });

    setIsLoadingReportChat(false);
    if (!request) {
      return;
    }

    setIsReported(true);
    dispatch(
      NotificationsActions.addNotification(
        intl.formatMessage({ id: `containers.chat.options.report.notification`, defaultMessage: 'Chat has been reported' })
      )
    );

    return () => {
      request.cancel();
    };
  }, [shouldReportChat]);

  return (
    <Button
      disabled={!discussion || !discussion.discussionId || isLoadingReportChat || shouldReportChat || isReported}
      onClick={() => setShouldReportChat(true)}
      isLoading={shouldReportChat && isLoadingReportChat}
      className="c-vertical-nav__item c-btn--text c-btn--show-text-with-loader"
      role="menuitem"
    >
      {intl.formatMessage({ id: 'containers.chat.options.report.label', defaultMessage: 'Report chat' })}
    </Button>
  );
};

export default ChatReport;
